import gql from "graphql-tag";

const UPDATE_FORM_SUBMISSION_STATUS = gql`
  mutation updateFormSubmissionStatus($form_submission_detail_ids: [Int!]!,$status_id: Int!) {
    updateFormSubmissionStatus(form_submission_detail_ids: $form_submission_detail_ids, status_id: $status_id) {
      message
      code
    }
  }
`;

export default UPDATE_FORM_SUBMISSION_STATUS;
